import { clsx } from 'clsx';
import * as React from 'react';
import * as styles from './flat.css';
import { Image, Label, UIHeading4, UIText2 } from '@cian/ui-kit';
import { Lock16 } from '@cian/ui-kit/prev';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var Flat = function Flat(_ref) {
  var onFlatHover = _ref.onFlatHover,
    hoveredFlatPlanId = _ref.hoveredFlatPlanId,
    id = _ref.id,
    url = _ref.url,
    img = _ref.img,
    title = _ref.title,
    price = _ref.price,
    booked = _ref.booked,
    hasDecoration = _ref.hasDecoration;
  var onClick = React.useCallback(function () {
    onFlatHover(null);
  }, [id]);
  var onMouseLeave = React.useCallback(function () {
    onFlatHover(null);
  }, [id]);
  var onMouseEnter = React.useCallback(function () {
    onFlatHover(id);
  }, [id]);
  return /*#__PURE__*/_jsxs("a", {
    target: "_blank",
    href: url,
    onClick: onClick,
    onMouseLeave: onMouseLeave,
    onMouseEnter: onMouseEnter,
    className: clsx(styles['flat'], hoveredFlatPlanId === id && styles['flat--hovered'], booked && styles['flat--booked']),
    rel: "noreferrer",
    "data-testid": "FlatItem",
    children: [/*#__PURE__*/_jsxs("div", {
      className: styles['img'],
      children: [/*#__PURE__*/_jsx(Image, {
        borderRadius: "4px",
        display: "block",
        src: img,
        width: 80,
        height: 80,
        objectFit: "contain"
      }), booked && /*#__PURE__*/_jsx("div", {
        className: styles['img--booked'],
        children: /*#__PURE__*/_jsx(Lock16, {
          color: "current_color"
        })
      })]
    }), /*#__PURE__*/_jsxs("div", {
      className: clsx(styles['description'], booked && styles['description--booked']),
      children: [/*#__PURE__*/_jsx(UIText2, {
        color: "current_color",
        children: title
      }), /*#__PURE__*/_jsx(UIHeading4, {
        color: "current_color",
        children: price
      }), /*#__PURE__*/_jsx("div", {
        className: styles['labels'],
        children: hasDecoration && /*#__PURE__*/_jsx(Label, {
          color: "text-primary-default",
          background: "surface-neutral-default",
          children: "\u0421 \u043E\u0442\u0434\u0435\u043B\u043A\u043E\u0439"
        })
      })]
    })]
  });
};